<template>
  <perseu-card :title="titleDialog">
    <template slot="content">
      <v-form ref="form" @submit.prevent="submitForm">
        <types-select
          label="Tipo"
          v-model="obj.type"
          :disabled="!!type"
          :rules="[$rules.required]"
        />
        <v-text-field
          v-model.trim="obj.name"
          label="Nome"
          :rules="[$rules.required]"
        />
        <select-lang v-model="obj.lang" :rules="[$rules.required]" />
      </v-form>
    </template>
    <template slot="actions">
      <v-btn color="secondary" @click="submitForm">Salvar</v-btn>
    </template>
  </perseu-card>
</template>

<script>
import { create, update } from "@/services/aggregations-service";

export default {
  components: {
    "types-select": () => import("@/components/Types/Select"),
  },
  props: {
    aggregation: {
      type: Object,
    },
    type: {
      type: Object | undefined,
      required: false,
    },
  },
  data: () => ({
    obj: { },
  }),
  computed: {
    titleDialog() {
      return (this.obj.id ? "Edição de" : "Novo") + " Agrupamento";
    },
  },
  mounted() {
    this.obj = this.aggregation || {};
    
    if (this.aggregation && this.aggregation.type) {
      this.type = this.aggregation.type;
    }
    
    if (this.type) {
      this.obj.type = this.type;
    }
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) return;
      try {
        this.$store.dispatch("loading/openDialog");

        if (!this.obj.id) {
          const { data } = await create(this.obj);
          this.$emit("create", data);
        } else {
          const { data } = await update(this.obj);
          this.$emit("update", data);
        }
        this.obj = {};
        this.$toasted.global.defaultSuccess();
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
  },
};
</script>

<style></style>
